import React from "react";
import AuthService from "../services/auth.service";
import IUser from "../types/user.type";
import {toast, ToastContainer} from "react-toastify";
import { t, subscribeLanguage } from "../i18n";

type Props = {};

type State = {
    isModerator: boolean,
    isAdmin: boolean,
    currentUser: IUser,
    rules: string
}

export default class AdminRuleEditor extends React.Component<Props, State> {
    private unsubscribeLang?: () => void;

    constructor(props: any) {
        super(props);
        this.state = {
            isModerator: false,
            isAdmin: false,
            currentUser: {} as IUser,
            rules: ""
        };
    }

    componentDidMount = () => {
        const user = AuthService.getCurrentUser();
        if (user == null || user.roles != "ROLE_ADMIN") {
            window.location.replace("/");
            return;
        }
        if (user) {
            this.setState({
                currentUser: user,
                isModerator: user.roles == "ROLE_MODERATOR",
                isAdmin: user.roles == "ROLE_ADMIN",
            });
        }
        this.getRules();
        this.unsubscribeLang = subscribeLanguage(() => this.forceUpdate());
    };

    componentWillUnmount() {
        this.unsubscribeLang?.();
    }

    getRules = () => {
        fetch('./assets/data/rules.data')
            .then(res => {
                return res.text();
            })
            .then(result => {
                    this.setState({
                        rules: result
                    })
                }
            );
    };

    UpdateRules = () => {
        AuthService.saveFileConfig('/assets/data/rules.data', this.state.rules).then(
            (result) => {
                window.location.reload();
            }
        );
    };

    ShowToast = (message: string) => {
        toast.error(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    render() {
        const {rules} = this.state;
        return (
            <div className="container-fluid">
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <div className="row">
                    <div className="col-lg-12 col-xlg-12 col-md-12">
                        <div className="card">
                            <div className="card-header text-center">
                                <div className="row">
                                    <div className="col-md-5 col-8 align-self-center">
                                        <div className="d-flex flex-wrap">
                                            <div className="m-r-20 align-self-center">
                                                <img src="assets/images/clockin.png" alt="assets/images/clockin.png"
                                                     width="25"/>
                                            </div>
                                            <h4 className="text-center m-t-10">{t('adminRuleEditor.title')}</h4>
                                        </div>
                                    </div>
                                    <div className="col-md-7 col-4 align-self-center">
                                        <button className="btn btn-success pull-right" type="submit"
                                                onClick={() => this.UpdateRules()}>{t('common.save')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="form-group">
                                    <div className="col-12">
                                        <textarea rows={100} cols={80} value={rules}
                                                  onChange={(e) => this.setState({rules: e.target.value})}
                                                  className="form-control form-control-line" name="content"
                                                  id="content"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}